import React from "react";
import ProfitStatusBadge from "../components/ProfitStatusBadge";
import { profitSettingsColumns } from "../data/profitData";

function renderValue(value, kind) {
  if (kind === "status-enabled") {
    return <ProfitStatusBadge status="enabled" label="Enabled" />;
  }

  if (kind === "status-active") {
    return <ProfitStatusBadge status="active" label="Active" />;
  }

  if (kind === "profit-badge-green" || kind === "profit-badge-amber") {
    return <span className={"profit-badge " + kind}>{value}</span>;
  }

  if (kind === "profit-tier-gold") {
    return <span className="profit-tier-badge profit-tier-gold">{value}</span>;
  }

  if (kind === "profit-mono") {
    return <span className="profit-mono">{value}</span>;
  }

  return value;
}

export default function ProfitSettingsPage() {
  return (
    <div className="profit-page">
      <div className="profit-page-header">
        <div className="profit-page-title">Settings</div>
        <div className="profit-page-subtitle">
          Partner account configuration
        </div>
      </div>

      <div className="profit-settings-grid">
        {profitSettingsColumns.map(function renderColumn(column, columnIndex) {
          return (
            <div className="profit-settings-column" key={columnIndex}>
              {column.map(function renderCard(card) {
                return (
                  <div className="profit-card" key={card.title}>
                    <div className="profit-settings-title">{card.title}</div>
                    {card.rows.map(function renderRow(row) {
                      return (
                        <div className="profit-settings-row" key={row[0]}>
                          <span className="profit-settings-key">{row[0]}</span>
                          <span className="profit-settings-value">
                            {renderValue(row[1], row[2])}
                          </span>
                        </div>
                      );
                    })}
                    {card.button || card.buttons ? (
                      <div className="profit-settings-actions">
                        {card.button ? (
                          <button className="profit-button profit-button-outline" type="button">
                            {card.button}
                          </button>
                        ) : null}
                        {card.buttons
                          ? card.buttons.map(function renderButton(label) {
                              return (
                                <button className="profit-button profit-button-outline" type="button" key={label}>
                                  {label}
                                </button>
                              );
                            })
                          : null}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
